<ng-container *ngIf="canDelete">
    <i *ngIf="!item.Archived" title="archive" (click)="archive($event)" class="fa fa-2x fa-fw fa-trash icon-main"></i>
    <i *ngIf="item.Archived" title="un-archive" (click)="archive($event)" class="fa fa-2x fa-fw fa-unlock icon-main"></i>
</ng-container>
